import React from 'react'
import ProposalScreen from '../../components/Proposal/ProposalScreen'

function ProposalDetail() {
	
	return <ProposalScreen />
}

export default ProposalDetail
